import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, ProgressSurveyQuestion } from 'utils/types';
import css from './MobileQuestion.css';
import Comment from "./Comment";

export default class MobileQuestion extends React.Component {

  get comment() {
    // Only show comment box if question is checked
    if ( !this.props.checked ) return null;
    return (
      <Comment
        studentId={this.props.studentId}
        studentName={this.props.studentName}
        numberOfQuestions={this.props.numberOfQuestions}
        question={this.props.question}
        onAnswerChanged={this.props.onAnswerChanged}
        answers={this.props.answers}
        isMobile={true}
      />
    );
  }

  render() {
    return (
      <div className={css['question']}>
        <div className={css['question-checkbox']} data-role="mobileProgressSurveyCheckbox">
          {this.props.renderCheckbox(this.props.question.id, this.props.question.name)}
          <label 
            className={css['checkbox-name']} 
            htmlFor={`${this.props.studentId}-${this.props.question.name}`}>
            {this.props.question.name}
          </label>
        </div>
        {this.comment}
      </div>
    )
  }
}

MobileQuestion.propTypes = {
  studentId: SFEntityID.isRequired,
  studentName: PropTypes.string.isRequired,
  question: ProgressSurveyQuestion.isRequired,
  renderCheckbox: PropTypes.func.isRequired,
  numberOfQuestions: PropTypes.number.isRequired,
  onAnswerChanged: PropTypes.func.isRequired,
  answers: PropTypes.array,
  checked: PropTypes.bool.isRequired
};
